import { SupportedLocales } from './types'

export function loadLocaleData(locale: SupportedLocales) {
    return import(`./compiled/${locale}.json`)
}
